<template>
<div class="containerLogin">
  <!--登录界面外层包裹容器-->
  <div class="login">
    <!--登录组件-->
    <div class="title">
      <div class="name">
        欢迎使用China-PCS系统
      </div>

      <div class="description">
        请登录
      </div>
    </div>

    <div class="loginForm">
      <el-form :model="fromMsg" status-icon :rules="rules" ref="fromMsg" class="loginMsg" v-loading="loading">
        <el-form-item prop="telephone" class="loginLable">
          <el-input v-model.number="fromMsg.telephone" @keyup.enter.native="login('fromMsg')" placeholder="手机号码" :clearable="clear"></el-input>
        </el-form-item>
        <el-form-item prop="password" class="loginLable">
          <el-input type="password" v-model="fromMsg.password" @keyup.enter.native="login('fromMsg')" placeholder="密码" :clearable="clear"></el-input>
        </el-form-item>
        <el-form-item prop="code" class="loginCode">
          <el-input v-model="fromMsg.code" placeholder="验证码" :clearable="clear" @keyup.enter.native="login('fromMsg')"></el-input>
          <div class="imgCode">
            <img :src="src" @click.prevent="newCode" ref="imgCode">
          </div>
        </el-form-item>

        <el-form-item class="loginLable loginButton">
          <el-button type="primary" @click="login('fromMsg')">登录</el-button>
          <el-button @click="resetForm('fromMsg')">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div class="loginFooter">
    <rtas-footer></rtas-footer>
  </div>
</div>
</template>

<script>
/*引入API根地址*/
import api from "../assets/javascript/api"
import rtasFooter from '../components/footer'

export default {
  api,
  name: "login",
  components:{
    rtasFooter
  },
  data() {
    /**
     * 校验规则
     * @param rule
     * @param value
     * @param callback
     * @returns {*}
     */
    let checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'));
      } else {
        callback();
      }
    };
    let checkTelephone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('手机号码不能为空'));
      } else if (typeof(value) !== 'number') {
        callback(new Error('手机号码不合法'));
      } else {
        callback();
      }
    };
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('密码不能为空'));
      } else if (value.length < 6) {
        callback(new Error('密码位数不足'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      /**
       * 表单值
       */
      fromMsg: {
        telephone: '',
        password: '',
        code: ''
      },
      /**
       * 是否可清除
       */
      /**
       * 验证码地址
       */
      src: api + 'img/code',
      clear: true,
      /**
       * 校验规则
       */
      rules: {
        telephone: [{
          required: true,
          validator: checkTelephone,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          validator: checkPassword,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          validator: checkCode,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    /**
     * 刷新验证码
     */
    newCode() {
      this.$refs.imgCode.src = api + 'img/code' + "?date=" + Date.now();
    },
    /**
     * 登录函数
     */
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let telephone = this.fromMsg.telephone;
          let password = this.fromMsg.password;
          let imageCode = this.fromMsg.code;
          let formData = new FormData;
          formData.append('telephone', telephone);
          formData.append('password', password);
          formData.append('imageCode', imageCode);
          this.loading = true;
          this.$http.post(
              '/user/login',
              formData, {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                withCredentials: true
              })
            .then((res) => {
              this.$message({
                message: "登陆成功",
                type: 'success',
                center: true,
                duration: 1500
              });
              setTimeout(() => {
                this.$router.push({
                  path: '/system/index'
                })
              }, 1500);
              window.localStorage["token"] = JSON.stringify(res.user.username);
              window.localStorage["user"] = JSON.stringify(res.user.userRole.roleId);
              window.localStorage["id"] = JSON.stringify(res.user.id);
              this.$nextTick(() => {
                this.loading = false;
              });
            })
            .catch((err) => {
              console.log(err);
              this.$nextTick(
                this.loading = false,
              );
            })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 重置函数
     * @param formName
     */
    resetForm(formName) {
      console.log(this.$refs[formName]);
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style scoped>
.containerLogin {
  width: 100%;
  height: 100%;
  /*登录界面背景图片（甲方提供）*/
  background-image: url("http://prod.resource.china-pcs.com/rtas/20191114/1573720043203_606.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login {
  width: 25%;
  height: 60%;
  min-width: 340px;
  min-height: 420px;
  /*border-radius: 2em;*/
  background-color: rgba(255, 255, 255, 0.7);
  margin-left: 56%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  width: 90%;
  height: 15%;
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1.6px solid #818679;
}
.name {
  font-size: 1.3em;
  font-family: 微软雅黑, serif;
  color: #818679;
}
.description {
  color: grey;
  font-family: 微软雅黑, serif;
  letter-spacing: 2.5px;
}
.loginForm {
  width: 90%;
  height: 65%;
  margin-top: 8%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.loginMsg {
  width: 90%;
  height: 80%;
}
.loginLable {
  width: 100%;
  height: 60px;
}
.loginLable .el-input {
  width: 100%;
  height: 50px;
  margin-top: 8px;
}
.loginCode {
  width: 60%;
  height: 60px;
}
.loginCode .el-input {
  width: 100%;
  height: 50px;
  margin-top: 8px;
}
.imgCode {
  width: 105px;
  height: 45px;
  position: absolute;
  margin-left: 110%;
  margin-top: -50px;
  cursor: pointer;
}
.imgCode img {
  width: 100%;
  height: 100%;
}
.loginButton {
  display: flex;
  justify-content: center;
}
.loginButton .el-button {
  width: 120px;
  height: 45px;
}
  .loginFooter{
    width: 100%;
    height: 5%;
    position: fixed;
    background-color: #E8EAED;
    bottom: 0;
  }
</style>

<style>
.loginLable .el-input__inner {
  width: 100%;
  height: 45px !important;
  font-size: 17px;
}

.loginCode .el-input__inner {
  width: 100%;
  height: 45px !important;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/login/login.vue